import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      <section className="relative h-screen overflow-hidden">
        {/* Background Video */}
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover "
        >
          <source src="\bytecs.mp4" type="video/mp4" />
        </video>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/35"></div>

        {/* Content */}
        <div className="relative z-10 flex items-center justify-center h-full">
          <div className="max-w-4xl text-center px-6">
            <span className="inline-block px-4 py-2 bg-[#18A9D5]-500/20 border border-[#18A9D5] rounded-full text-white text-sm mb-6">
              Innovative Technology Solutions
            </span>

            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight">
              Secure Every Entry
              <span className="block text-[#18A9D5]">
                Automate Every Process
              </span>
            </h1>

            <p className="mt-6 text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Smart workforce management, visitor tracking, and digital
              transformation solutions designed for modern enterprise agility.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to="/services"
                className="bg-[#18A9D5] hover:bg-[#18A9D5] text-white px-8 py-4 rounded-lg font-semibold transition"
              >
                Explore Services
              </Link>

              <Link
                to="/contact"
                className="border border-white text-white hover:bg-white hover:text-black px-8 py-4 rounded-lg font-semibold transition"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>

        {/* Scroll Down Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
          <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white rounded-full mt-2 animate-bounce"></div>
          </div>
        </div>
      </section>
      {/* <section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">

    <div className="text-center mb-10">
      <h2 className="text-3xl font-bold text-slate-900">
        Trusted By Businesses
      </h2>
    </div>

    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 items-center">
      <img src="/clients/client1.png" alt="" className="h-12 mx-auto" />
      <img src="/clients/client2.png" alt="" className="h-12 mx-auto" />
      <img src="/clients/client3.png" alt="" className="h-12 mx-auto" />
      <img src="/clients/client4.png" alt="" className="h-12 mx-auto" />
      <img src="/clients/client5.png" alt="" className="h-12 mx-auto" />
      <img src="/clients/client6.png" alt="" className="h-12 mx-auto" />
    </div>

  </div>
</section> */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          <img
            src="/Digital.png"
            alt="Bytecs"
            className="rounded-2xl shadow-lg"
          />

          <div>
            <h2 className="text-4xl font-bold text-slate-900 mb-6">
              Transforming Businesses Through Technology
            </h2>

            <p className="text-slate-600 leading-relaxed">
              Bytecs Technologies provides workforce management, Visitor
              management, security systems, and digital transformation solutions
              helping organizations improve productivity and operational
              excellence.
            </p>

            <button className="mt-8 bg-cyan-600 text-white px-6 py-3 rounded-xl">
              Learn More
            </button>
          </div>
        </div>
      </section>
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
            <div>
              <h3 className="text-5xl font-bold text-cyan-400">100+</h3>
              <p className="mt-3">Projects Delivered</p>
            </div>
            <div>
              <h3 className="text-5xl font-bold text-cyan-400">50+</h3>
              <p className="mt-3">Happy Clients</p>
            </div>

            <div>
              <h3 className="text-5xl font-bold text-cyan-400">10+</h3>
              <p className="mt-3">Years Experience</p>
            </div>

            <div>
              <h3 className="text-5xl font-bold text-cyan-400">24/7</h3>
              <p className="mt-3">Support</p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-center text-4xl font-bold mb-16">
            Industries We Serve
          </h2>

          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6">
            <div className="p-6 rounded-xl border text-center">
              🏥 Healthcare
            </div>

            <div className="p-6 rounded-xl border text-center">
              🏭 Manufacturing
            </div>

            <div className="p-6 rounded-xl border text-center">
              🏫 Education
            </div>

            <div className="p-6 rounded-xl border text-center">🏦 Banking</div>

            <div className="p-6 rounded-xl border text-center">
              🏢 Corporate
            </div>

            <div className="p-6 rounded-xl border text-center">🛒 Retail</div>
          </div>
        </div>
      </section>
      <section className="py-24 bg-[#18A9D5] text-white">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-5xl font-bold">
            Ready To Digitize Your Business?
          </h2>

          <p className="mt-6 text-lg text-cyan-100">
            Let's discuss how Bytecs Technologies can streamline operations and
            improve business efficiency.
          </p>

          <div className="mt-6">
            <Link
              to="/contact"
              className="mt-10 bg-white text-cyan-700 px-8 py-4 rounded-full font-semibold"
            >
              Get Free Consultation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
